import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import deLocales from './de-DE.json';
import enLocales from './en-GB.json';

const resources = {
  en: {
    translation: enLocales
  },
  de: {
    translation: deLocales
  }
};

export const defaultLanguage = 'de-DE';

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: defaultLanguage,
  interpolation: {
    escapeValue: false
  }
});
